export default "<app-card-table [showTitle]=\"false\" [columns]=\"columns\"></app-card-table>";